import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SecurityService} from '../../security.service';
import {DataStorageService} from '../../data-storage.service';
import {ConfigService} from '../../config.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ApiService} from '../../api.service';
import {PricingService} from '../../pricing.service';
import {ApiTextService} from '../../apiServices/text/text.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    public router: Router,
    public securityService: SecurityService,
    public dataStorageService: DataStorageService,
    private configService: ConfigService,
    private pricing: PricingService,
    private api: ApiService,
    private route: ActivatedRoute,
    private tApi: ApiTextService,
    private config: ConfigService
  ) {
  }

  ngOnInit() {

  }

  loginClick(user, pass) {
    this.dataStorageService.invalidCredentials = '';
    this.securityService.login(user, pass)
      .then(() => {
        this.tApi.getAllUITexts().then(res => this.dataStorageService.uiText = res);
        this.api.getCategories();
        this.api.getGlobalCategories();
        this.pricing.getPPHostedNodesPricelist().then(res => this.dataStorageService.nodesPricingPPhosted = res);
        if (this.securityService.isAdmin() && (!this.securityService.isUser() || !this.securityService.isLeader())) {
          this.router.navigate(['/management']);
        } else if (this.securityService.isUser() || this.securityService.isLeader()) {
          this.router.navigate(['/disclaimer']);
          // setTimeout(() => this.router.navigate(['/disclaimer']), 500);
        }
      }).catch(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        this.dataStorageService.invalidCredentials = 'Invalid Credentials';
      }
    });
  }

  listenForEnter(event: any) {
    // console.log(event);
    if (event.key === 'Enter' && event.currentTarget.id === 'username') {
      const passwordField = <HTMLInputElement>document.getElementById('password');
      if (passwordField.value.length === 0) {
        passwordField.focus();
      } else {
        const usernameField = <HTMLInputElement>document.getElementById('username');
        this.loginClick(usernameField.value, passwordField.value);
      }

      return;
    }
    if (event.key === 'Enter' && (event.currentTarget.id === 'password')) {
      const usernameField = <HTMLInputElement>document.getElementById('username');
      const passwordField = <HTMLInputElement>document.getElementById('password');
      this.loginClick(usernameField.value, passwordField.value);
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/content/login/login.component.ts